export function createAdfoxPuids({ sections, tags, type }) {
    return {
        puid1: sections?.map(({ url }) => url)?.join(':') || '',
        puid2: tags?.map(({ url }) => url)?.join(':') || '',
        puid3: type || '',
    };
}
